import IconButton from "components/utils/IconButton"
import React from "react"
import { useToasts } from "react-toast-notifications"
import styled from "styled-components"

const CopyId = styled.p`
  margin: 0;
  cursor: pointer;
`
const CopyIdSpan = styled.span`
  cursor: pointer;
`
const CopyIdPre = styled.pre`
  cursor: pointer;
`
const CopyIdButton = styled.button`
  cursor: pointer;
  background: var(--white);
  border: none;
  outline: none;
  padding: 0.25rem;
`

export default function CopyableString({
  prefix,
  stringToCopy,
  suffix,
  children,
  format = "p",
}: {
  prefix?: string
  stringToCopy: string
  suffix?: string
  children?: React.ReactNode
  format?: "p" | "span" | "pre" | "button" | "iconButton"
}) {
  const { addToast } = useToasts()

  function copyToClipboard() {
    const el = document.createElement("textarea")
    el.value = stringToCopy
    document.body.appendChild(el)
    el.select()
    document.execCommand("copy")
    document.body.removeChild(el)
    addToast("In Zwischenablage kopiert", {
      appearance: "success",
      autoDismiss: true,
    })
  }

  const innerContent = () => {
    return (
      <>
        {children ? (
          children
        ) : (
          <span>
            {`${typeof prefix === "string" ? `${prefix} ` : ""}${stringToCopy}${suffix ? ` ${suffix}` : ""}`}{" "}
          </span>
        )}
      </>
    )
  }

  if (format === "span") {
    return <CopyIdSpan onClick={copyToClipboard}>{innerContent()}</CopyIdSpan>
  }
  if (format === "pre") {
    return <CopyIdPre onClick={copyToClipboard}>{innerContent()}</CopyIdPre>
  }
  if (format === "button") {
    return <CopyIdButton onClick={copyToClipboard}>{innerContent()}</CopyIdButton>
  }
  if (format === "iconButton") {
    return <IconButton icon={children} onClick={copyToClipboard} />
  }
  return <CopyId onClick={copyToClipboard}>{innerContent()}</CopyId>
}
